import type { FunctionComponent } from "react";
import { PostStatus } from "../../../types/models/post.models.types";
import { useParams } from "react-router-dom";
import CampaignPostsBrandPartial from "../../../partials/brand/home/campaign-posts/campaign-posts.brand.partials";

export const CampaignDraftSubmissionsBrandScreen: FunctionComponent = () => {
	const { campaignId } = useParams();

	if (!campaignId) {
		throw new Error("campaign id not found");
	}

	return (
		<CampaignPostsBrandPartial
			tabs={[
				{
					status: PostStatus.draft,
					title: "Pending approval",
					flagged: false,
				},
				{
					status: PostStatus.draftApproved,
					title: "Approved",
					flagged: false,
				},
				{
					status: PostStatus.draftRejected,
					title: "Rejected",
					flagged: false,
				},
			]}
			initialStatus={PostStatus.draft}
			campaignId={campaignId}
		/>
	);
};
